export const discountTypeEnum = {
	POINTS: 1,
	PERCENTAGE: 2,
};
Object.freeze(discountTypeEnum);
